var estateStoreActions;
(function (estateStoreActions) {
    estateStoreActions["LIST_ESTATES"] = "LIST_ESTATES";
    estateStoreActions["GET_FORM_PROPS"] = "GET_FORM_PROPS";
    estateStoreActions["CREATE_ESTATE"] = "CREATE_ESTATE";
    estateStoreActions["UPDATE_ESTATE"] = "UPDATE_ESTATE";
    estateStoreActions["GET_ESTATE"] = "GET_ESTATE";
    estateStoreActions["GET_ESTATE_FROM_UUID"] = "GET_ESTATE_FROM_UUID";
    estateStoreActions["ATTACH_FILE"] = "ATTACH_FILE";
    estateStoreActions["ATTACH_UPDATE"] = "ATTACH_UPDATE";
    estateStoreActions["SET_STATE"] = "SET_STATE";
})(estateStoreActions || (estateStoreActions = {}));
export default estateStoreActions;
